"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumberedListProperty = exports.numberedListPropertyDefinition = void 0;
exports.numberedListPropertyDefinition = {
    view: {
        label: 'Numbered list',
        style: 'list-ordered',
    },
    constraints: [],
    type: 'rich-text',
    multiple: true,
    name: 'numbered-list',
};
const isNumberedListProperty = (prop) => {
    return prop.name === exports.numberedListPropertyDefinition.name;
};
exports.isNumberedListProperty = isNumberedListProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVtYmVyZWQtbGlzdC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL251bWJlcmVkLWxpc3QucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsZUFBZTtRQUN0QixLQUFLLEVBQUUsY0FBYztLQUN0QjtJQUNELFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsZUFBZTtDQUNVLENBQUE7QUFJMUIsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLElBQWtCLEVBQWdDLEVBQUU7SUFDekYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHNDQUE4QixDQUFDLElBQUksQ0FBQTtBQUMxRCxDQUFDLENBQUE7QUFGWSxRQUFBLHNCQUFzQiwwQkFFbEMifQ==